const FilterAvailableOptionsActions = {
    UPDATE_FILTER_AVAILABLE_OPTIONS_ACTION: 'UPDATE_FILTER_AVAILABLE_OPTIONS_ACTION',
};

export { FilterAvailableOptionsActions };